import { useDtfStore } from "./store";
import { cn } from "tailwind-variants";
import "./NotifyOnRestock.scss";

function NotifyOnRestock({ ...restProps }) {
  const store = useDtfStore();

  function isFavorite() {
    return store.isFavorite;
  }

  function productSlug() {
    return store.productSlug;
  }

  function transfersBusinessLineId() {
    // For DTF products, we always use Transfers business line
    // This value should match the actual Transfers business line ID
    return window.BUSINESS_LINES?.TRANSFERS || null;
  }

  return (
    <span
      {...restProps}
      className={cn(
        "product-details-quantity-form-row__notify-block js-notify-block scope-13df6e03",
        {
          "product-details-quantity-form-row__notify-block--monitored": isFavorite()
        },
        restProps.className
      )}
      data-color="Transfer"
      data-product-id={productSlug()}
      data-business-line-id={transfersBusinessLineId()}
    >
      <button
        className="product-details-quantity-form-row__monitored-for-restock js-product-details-notify-on-restock-unsubscribe scope-13df6e03"
        type="button"
        data-testid="product-details-quantity-form-row-monitored-for-restock"
      >
        {" "}
        Monitored For Restock{" "}
      </button>
      <button
        className="product-details-quantity-form-row__monitored-for-restock-mobile js-product-details-notify-on-restock-unsubscribe scope-13df6e03"
        type="button"
        data-testid="product-details-quantity-form-row-monitored-for-restock-mobile"
      >
        {" "}
        Notify on Restock{" "}
      </button>
      <button
        className="product-details-quantity-form-row__notify-on-restock js-product-details-notify-on-restock-modal-open scope-13df6e03"
        type="button"
        data-testid="product-details-quantity-form-row-notify-on-restock"
      >
        {" "}
        Notify on Restock{" "}
      </button>
    </span>
  );
}

export default NotifyOnRestock;
